import React from 'react';
import { theme } from '@shared/styles/theme';

/**
 * Loading spinner component.
 */
export const LoadingSpinner: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: '200px',
      }}
    >
      <div
        style={{
          border: `4px solid ${theme.colors.overlay.green10}`,
          borderRadius: '50%',
          borderTop: `4px solid ${theme.colors.primaryLight}`,
          width: '40px',
          height: '40px',
          animation: 'spin 1s linear infinite',
        }}
      />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};
